import React, { useState } from 'react';
import { Button } from "@twilio-paste/core/button";
import { Box } from "@twilio-paste/core/box";

interface RatingProps {
  onRate: (rating: number) => void;
}

const Rating: React.FC<RatingProps> = ({ onRate }) => {
  const [selectedRating, setSelectedRating] = useState<number | null>(null);

  const ratings = [1, 2, 3];

  const handleRatingClick = (rating: number) => {
    setSelectedRating(rating);
    onRate(rating);
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      {ratings.map((rating) => (
        <Box key={rating} marginRight="space20">
          <Button 
            variant={selectedRating === rating ? "primary" : "secondary"}
            onClick={() => handleRatingClick(rating)}
          >
            {rating}
          </Button>
        </Box>
      ))}
    </Box>
  );
};

export default Rating;
